import { render, staticRenderFns } from "./GenerateCodeAccess.vue?vue&type=template&id=2bc5afe3"
import script from "./GenerateCodeAccess.vue?vue&type=script&lang=js"
export * from "./GenerateCodeAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports